import { EventVenueMap } from 'src/components/Events/VenueMap/EventVenueMap';
import { SectionInfo } from 'src/WebApiController';

import { useOnSaleEventHeatMap } from './OnSaleEventHeatMap.hooks';

export const OnSaleEventHeatMap = ({
  selectedSectionIds,
  onSectionClicked,
  onToggleMirrors,
  onSelectedSectionsChange,
  isLocked,
}: {
  isLocked?: boolean;
  selectedSectionIds: number[];
  onSectionClicked: (e: MouseEvent, section: SectionInfo) => void;
  onToggleMirrors: (mirrors: SectionInfo[], exclude?: boolean) => void;
  onSelectedSectionsChange: (sections: SectionInfo[]) => void;
}) => {
  const { getColor, colorBandProps } = useOnSaleEventHeatMap(isLocked);

  return (
    <EventVenueMap
      isCondensedView
      getColor={getColor}
      selectedSectionIds={Array.from(selectedSectionIds)}
      markedSectionIds={Array.from(selectedSectionIds)}
      onSectionClicked={onSectionClicked}
      onToggleMirrors={onToggleMirrors}
      setSelectedSections={onSelectedSectionsChange}
      colorBandProps={colorBandProps}
      disableHoverEffect={isLocked}
    />
  );
};
